import React from "react";

const Telegram: React.FunctionComponent = () => (
  <svg xmlns="http://www.w3.org/2000/svg" width="21" height="17" viewBox="0 0 21 17" fill="none">
    <path fillRule="evenodd" clipRule="evenodd" d="M7.93795 11.1259L16.7248 3.35178C17.1027 2.98159 16.6303 2.88904 16.1579 3.16669L5.38693 9.83018L0.757335 8.44196C-0.281968 8.16431 -0.281969 7.42392 0.946299 6.96118L19.1813 0.112585C20.0317 -0.257609 20.7875 0.297683 20.5041 1.59336L17.3862 15.9384C17.1972 16.9564 16.5358 17.2341 15.6855 16.7713L10.9614 13.347L8.69381 15.4756C8.41036 15.7533 8.03243 15.7533 8.03243 15.4756L7.93795 11.1259Z"/>
  </svg>
)

export default Telegram
